import './StepModal.scss';
import React from 'react';
import {
  AAMBeaconButton,
  AAMBeaconModal
} from 'components/shared/Beacon';
import {
  decrementStep,
  incrementStep,
  resetStepModal,
  resetFundingMethod
} from 'state/missions/MissionActions';
import Store from 'state/Store';
import { connect } from 'react-redux';
import { getStepModalIndex } from 'state/missions/MissionsSelectors';
import {
  resetOnboardingMaintenanceOptOut,
  clearOnboardingMaintenanceOptOut
} from 'state/onboardingMaintenance/OnboardingMaintenanceActions';
import { validateBeaconForm } from 'components/shared/Beacon/BeaconFormValidation';
/*

The goal of this component is to provide an easy way to offer multi-step components via modal.

It has a pre-defined API in the form of a component map. It uses the shape of the below and requires DEFAULT as a key which will always be
initial display / step 1

{
  DEFAULT: [{
    component: <StepOne/>,
    previous: {
      label: 'previous',
      handlePrevious: () => {}
    },
    next: {
      label: 'next',
      handleNext: () => {}
    }
  }],
  CUSTOM_KEY: [
   {
    component: <StepOne/>,
    previous: {
      label: 'previous',
      handlePrevious: () => {}
    },
    next: {
      label: 'next',
      handleNext: () => {}
    }
   },
      {
    component: <StepTwo/>,
    previous: {
      label: 'previous',
      handlePrevious: () => {}
    },
    next: {
      label: 'next',
      handleNext: () => {}
    }
   }
  ]
}

 */

export const closeStepModal = (id) => {
  let modal = document.getElementById(id);
  if (modal) {
    modal.close();
  }
  Store.dispatch(resetOnboardingMaintenanceOptOut());
  Store.dispatch(clearOnboardingMaintenanceOptOut());
  Store.dispatch(resetFundingMethod());
  Store.dispatch(resetStepModal());
};

const StepModal = ({
  id,
  componentMap,
  currentStepIndex,
  stepKey,
  size = 'jumbo',
  show
}) => {
  const currentSteps = componentMap[stepKey];
  const numberOfSteps = currentSteps ? currentSteps.length : 1;
  const currentStep = currentSteps && currentSteps[currentStepIndex];
  if (currentStep) {
    const { component = null, previous, next, showStepCount } = currentStep;

    const previousAction = () => {
      if (previous) {
        if (previous.disable) {
          return;
        }
        if (previous.handlePrevious) {
          previous.handlePrevious();
        }
      }
      if (currentStepIndex === 0) {
        closeStepModal(id);
      } else {
        Store.dispatch(decrementStep());
      }
    };

    const nextAction = () => {
      if (next) {
        if (next.disable) {
          return;
        }
        if (next.handleNext) {
          next.handleNext();
        }
      }
      if (currentStepIndex < numberOfSteps - 1) {
        Store.dispatch(incrementStep());
      }
    };

    const handleSubmit = (event) => {
      event.preventDefault();
      validateBeaconForm(event);
      if(event.target.checkValidity()) {
        nextAction();
      }
    };

    return (
      //make ternary
      <div className="step-modal-container">
        <form onSubmit={handleSubmit} noValidate id="step-modal-form">
          {show && (
            <AAMBeaconModal
              open={show}
              size={size}
              id={id}
              dataMetricsLocation="PU"
              closeOnClickOut={false}
              onBeaconEventClose={(id) => closeStepModal(id)}>
              {component}
              <div slot="action-zone" className="action-zone-space-between">
                {previous && (
                  <AAMBeaconButton
                    id={'step-modal-previous'}
                    onBeaconEventClick={() => previousAction()}
                    variant={'tertiary'}
                    scale={'jumbo'}
                  >
                    {previous.label}
                    {previous.icon}
                  </AAMBeaconButton>
                )}
                {showStepCount && (
                  <span className="action-zone-label-text">
                    {currentStepIndex + 1} of {numberOfSteps}
                  </span>
                )}
                {next && (
                  <AAMBeaconButton
                    variant={next.variant}
                    type="submit"
                    disabled={next.disable}
                    scale={'jumbo'}
                  >
                    {next.label}
                    {next.icon}
                  </AAMBeaconButton>
                )}
              </div>
            </AAMBeaconModal>
          )}
        </form>
      </div>
    );
  }
  return null;
};

const mapStateToProps = (state) => ({
  currentStepIndex: getStepModalIndex(state)
});
export default connect(mapStateToProps)(StepModal);
